import {
  Typography,
  IconButton,
  Switch,
  Grid,
  makeStyles,
  Box,
} from '@material-ui/core';

import DeleteIcon from '@material-ui/icons/Delete';

import { observer } from 'mobx-react';
import { TableCell, TableRow } from '@material-ui/core';
import { deleteIconButtonStyle } from '../../utils/constants';
import {
  createCurrencyField,
  createPercentageField,
  createSelectField,
  createTextField,
} from '../temp/componentBuiderTemp';
import { useBaseStore } from '@roc/feature-app-core';
import { FeeFormStore } from '../../stores/common/feeFormStore';

interface FeeItemProps {
  store: FeeFormStore;
  onDeleteFee: (feeKey: string) => void;
}

const useStyles = makeStyles(theme => ({
  label: {
    fontWeight: 'bold',
    fontSize: '1rem',
  },
  activeLabel: {
    color: theme.palette.primary.main,
  },
  inactiveLabel: {
    color: theme.palette.text.secondary,
  },
  deleteButton: deleteIconButtonStyle,
  noBorders: {
    border: 'none',
  },
  disabled: {
    background: '#eee',
  },
}));

export const FeeItem = observer(
  ({ store, onDeleteFee }: FeeItemProps) => {
    const classes = useStyles();

    const feeKey = store.key;
    const displayPercentage = store.form.fields.usePercentage.value;
    const { globalStore } = useBaseStore();

    return (
      <TableRow>
        <TableCell
          component="th"
          scope="row"
          style={{ width: '20%' }}
          className={classes.noBorders}
        >
          {createTextField({
            store,
            testId: `name-${feeKey}`,
            fieldName: `name`,
            label: '',
            variant: 'standard',
          })}
        </TableCell>
        <TableCell
          align="center"
          component="th"
          scope="row"
          style={{ width: '20%' }}
          className={classes.noBorders}
        >
          <Box>
            {displayPercentage &&
              createPercentageField({
                store,
                testId: 'lenderPoints',
                fieldName: 'lenderPoints',
                label: null,
                autoFocus: true,
                limitedPercentage: true,
              })}
            {!displayPercentage &&
              createCurrencyField({
                label: null,
                fieldName: 'lenderAmount',
                testId: 'lenderAmount',
                store,
              })}
          </Box>
        </TableCell>
        <TableCell
          component="th"
          scope="row"
          style={{ width: '20%' }}
          className={classes.noBorders}
        >
          <Grid container alignItems="center" justifyContent="flex-start">
            <Grid item>
              <Typography
                className={`${classes.label} ${
                  !displayPercentage
                    ? classes.activeLabel
                    : classes.inactiveLabel
                }`}
              >
                $
              </Typography>
            </Grid>
            <Grid item>
              <Switch
                checked={displayPercentage}
                onChange={() => store.toggleTypeOfValue()}
                color="primary"
                inputProps={{ 'aria-label': 'controlled' }}
              />
            </Grid>
            <Grid item>
              <Typography
                className={`${classes.label} ${
                  displayPercentage
                    ? classes.activeLabel
                    : classes.inactiveLabel
                }`}
              >
                %
              </Typography>
            </Grid>
            <Grid item>
              <IconButton
                className={classes.deleteButton}
                onClick={() => {
                  onDeleteFee(feeKey);
                }}
              >
                <DeleteIcon />
              </IconButton>
            </Grid>
          </Grid>
        </TableCell>
      </TableRow>
    );
  }
);
